import { Card, CardBody, Col, Form, FormGroup, Row } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { Emi, EmiBankSelect, EmiCardSelect, EmiYearSelect, Submit } from "../../../Constant";
import FormGroupCommon from "./Common/FormGroupCommon";
import { Btn, Image, LI, UL } from "../../../AbstractElements";
import SelectCommon from "./Common/SelectCommon";
import { dynamicImage } from "../../../Service/DynamicImage";

const EmiForm = () => {
  return (
    <Col xl="4" lg="6" className="box-col-33">
      <Card>
        <CommonCardHeader title={Emi} />
        <CardBody>
          <Form className="theme-form" onSubmit={(e) => e.preventDefault()}>
            <Row>
              <FormGroupCommon type="text" placeholder="First Name" formClass="col-6 p-r-0" />
              <FormGroupCommon type="text" placeholder="Last name" formClass="col-6" />
              <FormGroupCommon type="text" placeholder="Pincode" formClass="col-6  p-r-0" />
              <SelectCommon size={1} data={EmiBankSelect} selectClass="col-6" />
              <SelectCommon size={1} data={EmiCardSelect} selectClass="col-12" />
              <SelectCommon size={1} data={EmiYearSelect} selectClass="col-12" />
              <FormGroup className="col-12">
                <UL className="payment-opt simple-list d-flex flex-row">
                  <LI><Image src={dynamicImage("ecommerce/mastercard.png")} alt="" /></LI>
                  <LI><Image src={dynamicImage("ecommerce/visa.png")} alt="" /></LI>
                  <LI><Image src={dynamicImage("ecommerce/paypal.png")} alt="" /></LI>
                </UL>
              </FormGroup>
              <Col xs="12">
                <Btn color="primary" className="btn-block">
                  {Submit}
                </Btn>
              </Col>
            </Row>
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default EmiForm;
